import { css } from '@flipster/styled-system/css';

export const maxWStyles = css.raw({
  w: 'auto',
  maxW: { tablet: 'desktopMaxWidth' },
  mx: { base: 16, smallDesktop: 'auto' },
});

export const maxWStylesWithMargin = css.raw({
  w: 'auto',
  maxW: { tablet: 'desktopMaxWidth' },
  mx: { base: 16, smallDesktop: 'auto' },
  mt: { base: 56, tablet: 100 },
});

export const sectionSmallHeadingStyles = css.raw({
  textStyle: 'Title/M',
  color: 'content.default.level-5',
  mb: { base: 16, tablet: 24 },
});

export const sectionLargeHeadingStyles = css.raw({
  textStyle: 'Display/XL',
  color: 'content.default.level-5',
  mb: { base: 12, tablet: 24 },
  tabletDown: { whiteSpace: 'pre-line' },
  textAlign: 'center',
});

export const sectionSubHeadingStyles = css.raw({
  textStyle: 'Title/XS',
  color: 'content.default.level-3',
  mb: { base: 32, tablet: 40 },
  textAlign: 'center',
});
